import { useQuery } from '@tanstack/react-query';
import { fetchMfaRequiredRoles } from '@/services/adminUsers';

const QUERY_KEY = ['mfa-required-roles'] as const;
const STALE_TIME = 5 * 60_000;
const FALLBACK_ROLES = ['super-admin', 'amministrazione'];

export function useMfaRequiredRoles() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: fetchMfaRequiredRoles,
    staleTime: STALE_TIME,
    gcTime: 10 * 60_000,
    placeholderData: FALLBACK_ROLES,
  });
}

export async function getMfaRequiredRoleCodes(): Promise<string[]> {
  try {
    return await fetchMfaRequiredRoles();
  } catch {
    return FALLBACK_ROLES;
  }
}

export { QUERY_KEY as MFA_REQUIRED_ROLES_QUERY_KEY };
